<template>
  <div class="annuaire-assurances">
    <div class="annuaire-recherche">
      <div class="annuaire-champ">
        <label :for="'annuaire-recherche-' + _uid">{{ convention ? 'Rechercher une société' : 'Rechercher une compagnie' }}</label>
        <input :id="'annuaire-recherche-' + _uid" v-model="recherche" type="search" class="ui-search-field"
          placeholder="Nom, téléphone, email ou adresse…" autocomplete="off">
      </div>
      <span class="annuaire-compte" aria-live="polite">{{ filtrees.length }} {{ convention ? 'société(s)' : 'compagnie(s)' }}<template v-if="recherche"> sur {{ fiches.length }}</template></span>
    </div>
    <b-table :id="'annuaire-table-' + _uid" class="annuaire-table" hover responsive show-empty
      :items="filtrees" :fields="colonnes" :current-page="page" :per-page="20" primary-key="id">
      <template #cell(nom)="{ item }">
        <router-link class="annuaire-nom" :to="'/parametres/assureur/' + item.id">{{ item.nom }}</router-link>
        <span class="annuaire-secondaire">{{ item.adresse || 'Adresse non renseignée' }}</span>
      </template>
      <template #cell(coordonnees)="{ item }">
        <span v-if="item.telephone" class="annuaire-contact">{{ item.telephone }}</span>
        <span v-if="item.email" class="annuaire-contact annuaire-email">{{ item.email }}</span>
        <span v-if="!item.telephone && !item.email" class="annuaire-secondaire">Non renseignées</span>
      </template>
      <template #cell(statut)="{ item }">
        <span :class="['annuaire-statut', 'annuaire-statut--' + item.ton]">{{ item.statut }}</span>
        <span v-if="item.periode" class="annuaire-secondaire">{{ item.periode }}</span>
      </template>
      <template #cell(mode)="{ item }">
        <strong class="annuaire-mode">{{ item.mode }}</strong>
        <span v-for="detail in item.precisions" :key="detail" class="annuaire-secondaire">{{ detail }}</span>
      </template>
      <template #cell(actions)="{ item }">
        <div class="annuaire-actions">
          <router-link class="annuaire-ouvrir" :to="'/parametres/assureur/' + item.id" :aria-label="'Ouvrir la fiche de ' + item.nom">Ouvrir</router-link>
          <b-dropdown right boundary="viewport" variant="link" no-caret class="annuaire-menu" :toggle-attrs="{ 'aria-label': 'Actions pour ' + item.nom }">
            <template #button-content><span aria-hidden="true">⋮</span></template>
            <b-dropdown-item-button @click="$emit('modifier', item)">Modifier</b-dropdown-item-button>
            <b-dropdown-item-button variant="danger" @click="$emit('supprimer', item)">Supprimer…</b-dropdown-item-button>
          </b-dropdown>
        </div>
      </template>
      <template #empty>
        <div class="annuaire-vide"><strong>Aucun résultat</strong><p>Essayez un autre nom ou effacez la recherche.</p><button type="button" class="btn btn-link" @click="recherche = ''">Effacer la recherche</button></div>
      </template>
    </b-table>
    <div class="annuaire-pied" v-if="filtrees.length">
      <span>{{ (page - 1) * 20 + 1 }}–{{ Math.min(page * 20, filtrees.length) }} sur {{ filtrees.length }}</span>
      <b-pagination v-if="filtrees.length > 20" v-model="page" :total-rows="filtrees.length" :per-page="20"
        :aria-controls="'annuaire-table-' + _uid" aria-label="Pages de l’annuaire" label-first-page="Première page"
        label-prev-page="Page précédente" label-next-page="Page suivante" label-last-page="Dernière page" />
    </div>
  </div>
</template>
<script>
import { BTable, BPagination, BDropdown, BDropdownItemButton } from 'bootstrap-vue'
import { ligneAnnuaire, normaliserRecherche } from './annuaire-utils'
export default {
    name: 'AnnuaireAssurances',
    components: { BTable, BPagination, BDropdown, BDropdownItemButton },
    props: { fiches: { type: Array, default: () => [] }, type: { type: String, default: 'assurance' } },
    data: () => ({ recherche: '', page: 1 }),
    computed: {
        convention() { return this.type === 'convention' },
        colonnes() {
            const champs = [{ key: 'nom', label: this.convention ? 'Société' : 'Compagnie', sortable: true },
                { key: 'coordonnees', label: 'Coordonnées' }, { key: 'statut', label: this.convention ? 'Contrat' : 'Souscripteurs', sortable: true }]
            if (this.convention) champs.push({ key: 'mode', label: 'Facturation', sortable: true })
            return champs.concat({ key: 'actions', label: 'Actions', thClass: 'text-right' })
        },
        filtrees() {
            const q = normaliserRecherche(this.recherche)
            return this.fiches.map(fiche => ligneAnnuaire(fiche)).filter(fiche => !q || fiche.recherche.includes(q))
        }
    },
    watch: { recherche() { this.page = 1 }, type() { this.page = 1; this.recherche = '' }, fiches() { this.page = 1 } }
}
</script>
<style scoped lang="scss">
.annuaire-assurances { color: var(--ui-text, #172033); }
.annuaire-recherche { display: flex; align-items: flex-end; gap: 16px; margin-bottom: 20px; }
.annuaire-champ { flex: 1; min-width: 0; }
.annuaire-champ label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 7px; color: var(--ui-text-secondary, #273449); }
.annuaire-champ input { width: 100%; }
.annuaire-compte { padding-bottom: 14px; white-space: nowrap; font-size: 13px; color: var(--ui-text-muted, #526074); }
.annuaire-table { border: 1px solid #dce4f2; border-radius: 14px; margin: 0; }
.annuaire-table ::v-deep table { min-width: 850px; margin: 0; font-size: 14px; }
.annuaire-table ::v-deep th { border-top: 0; border-bottom: 1px solid #dce4f2; padding: 12px 16px; background: #f4f7fc; color: var(--ui-text-secondary, #273449); font-size: 12px; font-weight: 600; white-space: nowrap; }
.annuaire-table ::v-deep td { border-top: 1px solid #e3e9f4; padding: 16px; vertical-align: middle; background: transparent; }
.annuaire-table ::v-deep tbody tr:hover { background: #f2f7ff; }
.annuaire-table ::v-deep td:first-child { width: 27%; min-width: 210px; }
.annuaire-nom { display: inline-block; font-size: 15px; font-weight: 700; color: var(--ui-text, #172033); overflow-wrap: anywhere; }
.annuaire-nom:hover { color: var(--ui-accent, #2457c5); }
.annuaire-secondaire { display: block; font-size: 12px; line-height: 1.5; color: var(--ui-text-muted, #526074); margin-top: 4px; max-width: 280px; overflow-wrap: anywhere; }
.annuaire-contact { display: block; line-height: 1.6; font-size: 13px; }
.annuaire-email { overflow-wrap: anywhere; max-width: 230px; }
.annuaire-mode { font-size: 13px; font-weight: 600; white-space: nowrap; }
.annuaire-statut { display: inline-block; border-radius: 7px; padding: 4px 8px; font-size: 12px; font-weight: 600; background: #edf2fa; color: #273449; white-space: nowrap; }
.annuaire-statut--succes { background: #edf8f2; color: #166044; }
.annuaire-statut--attention { background: #fff3e1; color: #80510b; }
.annuaire-statut--bleu { background: #edf3ff; color: #2457c5; }
.annuaire-actions { display: flex; justify-content: flex-end; align-items: center; gap: 6px; }
.annuaire-ouvrir { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; padding: 6px 12px; border: 1px solid #ccd8ed; border-radius: 9px; font-size: 13px; color: #2457c5; background: white; }
.annuaire-menu ::v-deep .dropdown-toggle { width: 36px; min-height: 36px; padding: 0; font-size: 24px; line-height: 1; border: 1px solid #dce4f2; border-radius: 9px; text-decoration: none; color: #273449; }
.annuaire-menu ::v-deep .dropdown-item { min-height: 40px; font-size: 14px; }
.annuaire-pied { display: flex; align-items: center; justify-content: flex-end; gap: 20px; padding-top: 16px; font-size: 12px; color: var(--ui-text-muted, #526074); }
.annuaire-pied ::v-deep .pagination { margin: 0; }
.annuaire-vide { padding: 24px; text-align: center; }
.annuaire-vide p { margin: 6px 0; }
a:focus-visible, button:focus-visible, ::v-deep button:focus-visible { outline: 2px solid #2457c5; outline-offset: 2px; }
@media (max-width: 650px) {
    .annuaire-recherche { flex-direction: column; align-items: stretch; gap: 8px; }
    .annuaire-compte { padding: 0; }
    .annuaire-pied { flex-wrap: wrap; gap: 10px; }
}
</style>
